import styled from "styled-components";

const MessageWrapper = styled.div`
  color: black;
  background-color: #f3f4f6;
  padding: 12px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  max-width: 70%;

  p {
    margin-bottom: 0.5rem;
    line-height: 1.4;
  }

  p:last-child {
    margin-bottom: 0;
  }

  ul,
  ol {
    margin-left: 1.2rem;
    margin-bottom: 0.5rem;
    list-style-type: disc;
  }

  a {
    color: #2563eb; /* bleu */
    text-decoration: underline;
  }

  strong {
    font-weight: 600;
  }
`;

export function BotMessage({message}: {message: string}) {
  return (
    <div className="flex justify-start">
      <MessageWrapper dangerouslySetInnerHTML={{__html: message}} />
    </div>
  );
}
